import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { DevTools } from 'jotai-devtools'
import css from 'jotai-devtools/styles.css?inline'
import { Suspense } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'

import { AuthStateProvider } from '@app/contexts/AuthProvider/AuthProvider'
import { useSubDomain } from '@app/hooks/useSubdomain'
import { useChangeTempRole } from '@app/modules/Admin/hooks/useChangeTempRole'
import { RiskMapSync } from '@app/risk-migration/hooks/useSyncLayersToMap'
import { RexRoutes } from '@app/routes/RexRoutes'
import { theme } from '@app/styles/theme'
import { BuildSash } from './BuildSash'
import { LocalDbSash } from './LocalDbSash'

const isLocalDevelopment = import.meta.env.VITE_UI_ENV === 'local'
const isOnDevServer = import.meta.env.VITE_UI_ENV === 'development'

const JotaiDevTools = () =>
  isLocalDevelopment ? (
    <>
      <style>{css}</style>
      <DevTools position="bottom-right" />
    </>
  ) : null

export const App = () => {
  useSubDomain()
  useChangeTempRole()

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />

      {isLocalDevelopment && <JotaiDevTools />}

      <RiskMapSync />

      <Router>
        {isOnDevServer && <BuildSash />}
        {isLocalDevelopment && <LocalDbSash />}

        {/* NOTICE: AppLoader This is the Old App.tsx will be replaced as refactoring progresses */}
        <AuthStateProvider>
          <Suspense fallback={null}>
            <RexRoutes />
          </Suspense>
        </AuthStateProvider>
      </Router>

      {isLocalDevelopment && <ReactQueryDevtools />}
    </MuiThemeProvider>
  )
}
